import * as XLSX from "xlsx";

const NUM_FMT = "#,##0.00";

// columns: [{ header, get: (row) => value, num?: true, width? }]
// sheets:  [{ name, columns, rows, footer?: [] , title?, subtitle? }]
export function exportExcel(filename, sheets, company) {
  const wb = XLSX.utils.book_new();
  sheets.forEach((s) => {
    const aoa = [];
    const headRows = [];
    if (company?.name) headRows.push([company.name]);
    if (s.title) headRows.push([s.title]);
    if (s.subtitle) headRows.push([s.subtitle]);
    if (headRows.length) { aoa.push(...headRows); aoa.push([]); }
    const headerAt = aoa.length;
    aoa.push(s.columns.map((c) => c.header));
    s.rows.forEach((r) => aoa.push(s.columns.map((c) => cell(c.get(r)))));
    if (s.footer) aoa.push(s.footer.map(cell));
    const ws = XLSX.utils.aoa_to_sheet(aoa);
    ws["!cols"] = s.columns.map((c) => ({ wch: c.width || Math.max(12, String(c.header).length + 2) }));
    ws["!freeze"] = { xSplit: 0, ySplit: headerAt + 1 };
    s.columns.forEach((c, ci) => {
      if (!c.num) return;
      for (let ri = headerAt + 1; ri < aoa.length; ri++) {
        const ref = XLSX.utils.encode_cell({ r: ri, c: ci });
        if (ws[ref] && typeof ws[ref].v === "number") ws[ref].z = NUM_FMT;
      }
    });
    XLSX.utils.book_append_sheet(wb, ws, String(s.name || "Sheet").replace(/[\\/?*[\]:]/g, " ").slice(0, 31));
  });
  XLSX.writeFile(wb, filename.endsWith(".xlsx") ? filename : `${filename}.xlsx`);
}

const cell = (v) => (v === null || v === undefined ? "" : v);
export const n = (v) => (v === null || v === undefined || v === "" || isNaN(Number(v)) ? "" : Number(v));
export const stamp = () => new Date().toISOString().slice(0, 10);
